module.exports = __webpack_public_path__ + "media/investment.61b92d2d.svg";